'use client'

import { useResponsive } from '@dustin-web/microsite-components/src/hooks'
import {
  Touchpoint,
  type GetAutocompleteE4Query,
  type GetAutocompleteE4QueryVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { GET_AUTOCOMPLETE } from '@dustin-web/microsite-data/src/graphql/product/get-autocomplete.graphql'

export function useAutocomplete(searchPhrase: string) {
  const { isSmallScreen } = useResponsive()
  const touchpoint = isSmallScreen ? Touchpoint.Mobile : Touchpoint.Desktop
  const shouldQuery = searchPhrase.length >= 2

  const { data, isValidating, error } = useGraphql<
    GetAutocompleteE4Query,
    GetAutocompleteE4QueryVariables
  >(
    GET_AUTOCOMPLETE,
    {
      variables: { searchPhrase, touchpoint },
    },
    shouldQuery
  )

  return {
    data,
    isLoading: isValidating,
    error: error ?? null,
  }
}
